import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormsModule, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { DocumentService } from '@app/shared/services';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
import { CommonModule, NgClass, NgStyle } from '@angular/common';
@AutoUnsubscribe()
@Component({
    selector: 'rename-institution-dialog',
    templateUrl: './rename-institution-dialog.component.html',
    styleUrl: './rename-institution-dialog.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
      CommonModule,
      FormsModule,
      NgClass,
      NgStyle
    ]
})
export class RenameInstitutionDialogComponent implements OnInit, OnDestroy {
  institutionName = '';
  templateForm: FormGroup;
  subscription = new Subscription();
  constructor(
    private dialogRef: MatDialogRef<RenameInstitutionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private cd: ChangeDetectorRef,
    private documentService: DocumentService
  ) {
    this.templateForm = this.fb.group({
      name: [data.templateName, [Validators.required, Validators.maxLength(100)]],
    });
  }

  ngOnInit(): void {
    this.institutionName = this.data.currentInstitutionName;
  }

  confirmDialog() {
    if (this.institutionName.trim() !== '') {
      if (this.data.isDiscoveryType6) {
        this.dialogRef.close({
          confirmation: true,
          institutionName: this.institutionName,
        });
      } else {
        this.onSave();
      }
    } else {
      this.toastr.error('Please provide a client group name');
    }
  }

  onSave(): void {
    let nameValue = this.templateForm.get('name')?.value || '';
    nameValue = nameValue.trimStart();
    if (!nameValue) {
      return;
    }
    this.templateForm.get('name')?.setValue(nameValue);
    if (this.templateForm.valid) {
      this.subscription.add(
        this.documentService
          .saveFormNameInDb(
            {
              form_name: this.templateForm.get('name')?.value,
              id: this.data.data.id,
              user_id: this.data.data.user_id,
              document_name: this.data.data.form_name,
              auto_naming_disabled: false,
            },
            true
          )
          .subscribe(
            () => {
              this.dialogRef.close({
                confirmation: true,
                institutionName: this.institutionName,
                name: this.templateForm.get('name')?.value,
              });
            },
            (error) => {
              console.error('Error saving form:', error);
            }
          )
      );
    }
  }

  onNameInput(event: any) {
    this.institutionName = this.institutionName.trim();

    const input = event.target;
    const value = input.value;

    // Check if the first character is a special character
    if (/^[\s`~!@#$%\^&*()_+={}|[\]\\:';"<>?,./]/.test(value.charAt(0))) {
      input.value = value.slice(1); // Remove the first special character
    }

    // Manually trigger form control update
    this.templateForm.get('name')?.setValue(input.value, { emitEvent: false });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
